

class AuthenticationSystem {
  framework;
  accessToken;
  userInfo;


  constructor(_framework) {
    this.framework = _framework;
  }

  async loginSystemUser(email, password) {
    let appError = null;
    //let processedPassword = this.framework.getMD5(password);
    let processedPassword = password;
    const response = await this.framework.getRestSystem().authenticateSystemUser(email, processedPassword).catch(error => {
      appError = error;
      return null;
    });    
    if(response !== null) {
      const data = response.data;   
      console.log("data");
      console.log(data);
      if(data !== undefined) {
        const accessToken = data.token;
        const systemUserData = data.systemUserData;
        const systemUser = systemUserData.systemUser;
        const staffUser = systemUserData.staffUser;
        const systemUserTypePrivilegeArray = systemUserData.systemUserTypePrivilegeArray;        
        const restMerchantData = data.restMerchantData;
        let userPrivilegeArray = [];

        
        console.log("\n_____________________________________systemUser");
        console.log(systemUser);
        console.log("\n_____________________________________staffUser");
        console.log(staffUser);

        if(systemUserTypePrivilegeArray !== null && systemUserTypePrivilegeArray !== undefined) {
          for(let i=0; i < systemUserTypePrivilegeArray.length; i++) {
            const systemUserTypePrivilege = systemUserTypePrivilegeArray[i];
            let userPrivilege = {
              privilegeId : systemUserTypePrivilege.systemUserTypePrivilegeId,
              privilegeCode : systemUserTypePrivilege.privilegeCode,
              userTypeId : systemUserTypePrivilege.systemUserTypeId,
              userRole : systemUserTypePrivilege.systemUserRole,
              userTypeCode : systemUserTypePrivilege.systemUserTypeCode,
              name : systemUserTypePrivilege.name,
              description : systemUserTypePrivilege.description,
              activeFlag : systemUserTypePrivilege.activeFlag,              
            };
            userPrivilegeArray.push(userPrivilege);
          }
        }
        const userInfo  =  {
          id: systemUser.loginName,
          entityType: "SystemUser",
          scope: "system",
          userType: systemUser.systemUserType,
          name: systemUser.userFullName,
          email: systemUser.email,
          userId: systemUser.systemUserId,
          systemUserId: systemUser.systemUserId,
          staffUserId: staffUser.staffUserId,
          userPrivilegeArray: userPrivilegeArray,
        };		
        let userInfoString = JSON.stringify(userInfo);
        localStorage.setItem("accessToken",accessToken);
        localStorage.setItem("userInfo",userInfoString);
        localStorage.setItem("staffUserId",staffUser.staffUserId);
        this.accessToken = accessToken;
        this.userInfo = userInfo;
        if(restMerchantData != null) {
          this.framework.getMerchantManagementSystem().setMerchantData(restMerchantData.merchantAccount,restMerchantData.merchantProductArray);
        }
        
        return data;                
      }
      else {
        return null;
      } 
    }
    else {
      throw appError;
    }
  }

  logout() {
    this.accessToken = null;
    this.userInfo = null;
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("staffUserId");  
  }

  isUserAuthenticated() {
    return (this.accessToken !== null && this.userInfo !== null);
  }

  register(username, email, password) {
    return null;
  }

  getAccessToken() {
    return localStorage.getItem('accessToken');
  }

  getUserInfo() {
    return JSON.parse(localStorage.getItem('userInfo'));
  } 

  getStaffUserId() {
    return localStorage.getItem('staffUserId');
  }

  hasValidUserPrivilege(_privilegeCode) {
    let userInfo = this.userInfo;
    if(userInfo !== null) {
      if(userInfo.userPrivilegeArray != null) {
          if(userInfo.userPrivilegeArray.length > 0) {
              for(let i=0; i< userInfo.userPrivilegeArray; i++) {
                let userPrivilege = userInfo.userPrivilegeArray[i];
                if(userPrivilege.privilegeCode === _privilegeCode) {
                  if(userPrivilege.activeFlag === 'Y') {
                      return true;
                  }
                }
              }
          }
      }
    }
    return false;    
  }  
}

export default AuthenticationSystem;

